import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  loading: false,
  guestBillDetailsData: null,
  error: null,
};

const guestBillDetailsSlice = createSlice({
  name: 'guestBillDetails',
  initialState,
  reducers: {
    resetGuestBillDetails: () => initialState,
    guestBillDetailsRequest: state => {
      state.loading = true;
      state.error = null;
    },
    guestBillDetailsSuccess: (state, action) => {
      state.loading = false;
      state.guestBillDetailsData = action?.payload;
    },
    guestBillDetailsFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const { resetGuestBillDetails, guestBillDetailsRequest, guestBillDetailsSuccess, guestBillDetailsFailure } = guestBillDetailsSlice.actions;

export default guestBillDetailsSlice.reducer;
  